module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Tony qualified in Law and practiced as a solicitor in his country of birth, South Africa before emigrating to Israel in 1961. Since then, after a stint on a kibbutz, he lectured at the Tel Aviv University and opened a chain of fast food restaurants and established a travel company specializing in incentive travel. The company won several international awards. For the last 34 years, as a highly respected trainer, he has conducted seminars in personal development and self-awareness in Israel, Turkey, the United Kingdom and around the world with his wife, Orit Josefi Wiseman in their company, Outlook. He has also been a coach and mentor, often dealing with issues pertaining to intimate relationships, which formed the basis of the book, Relationships I.Q., written together with Orit and published by Austin Macauley.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0